var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "org-wrap" },
    [
      !_vm.hideBlackTitle
        ? _c(
            "div",
            { staticClass: "com-Breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: ">" } },
                [
                  _c(
                    "el-breadcrumb-item",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: { to: "/console/member" }
                        },
                        [_vm._v("成员管理")]
                      )
                    ],
                    1
                  ),
                  _c("el-breadcrumb-item", [_vm._v("调整组织架构")])
                ],
                1
              ),
              _c(
                "a",
                {
                  staticClass: "r-btn",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/console/member" })
                    }
                  }
                },
                [_vm._v("返回上一步")]
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "table-style" }, [
        _c("div", { staticClass: "title-lab" }, [
          _vm._m(0),
          _vm.isAdmin
            ? _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.synchronous }
                    },
                    [_vm._v("同步组织架构")]
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content:
                          "若当前账号已在君子签SaaS中使用并有成员加入，受钉钉限制，同步后成员的部门信息需重新设置",
                        placement: "top-start"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _c("div", { staticStyle: { padding: "20px" } }, [
          _c("table", { staticClass: "el-table" }, [
            _vm._m(1),
            _c(
              "tbody",
              { ref: "referenceTBody" },
              [
                _vm.treeGroup.length === 0
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center", color: "red" },
                          attrs: { colspan: "3" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s("暂无数据-" + _vm.errorDescription) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._l(_vm.treeGroup, function(v, index) {
                  return _c(
                    "tr",
                    {
                      key: index,
                      staticStyle: {
                        "line-height": "45px",
                        "border-bottom": "1px solid #ebeef5"
                      },
                      attrs: {
                        trindexid: "trindexid" + index + v.corpGroupId,
                        level: 0
                      }
                    },
                    [
                      _c("td", [
                        v.childCorpGroups
                          ? _c(
                              "span",
                              {
                                staticClass: "expand-icon-style",
                                on: {
                                  click: function($event) {
                                    return _vm.expandFirstClick(v, index)
                                  }
                                }
                              },
                              [
                                !v.expand
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-plus"
                                    })
                                  : _vm._e(),
                                v.expand
                                  ? _c("i", { staticClass: "el-icon-remove" })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(
                          "\n              " +
                            _vm._s(v.groupName) +
                            "\n            "
                        )
                      ]),
                      _c("td", [_vm._v(_vm._s(v.totalNum))]),
                      _c("td", [_vm._v(_vm._s(v.corpGroupManName || "~~~"))]),
                      _c("td", [
                        v.editFlag === 1
                          ? _c("div", { staticClass: "custom-btn" }, [
                              _c(
                                "a",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { href: "javascript:void(0);" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClickAddChild(v)
                                    }
                                  }
                                },
                                [_vm._v("添加下级")]
                              ),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0);" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClickSetManager(v)
                                    }
                                  }
                                },
                                [_vm._v("设置主管")]
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.visibleDialogTitle,
            visible: _vm.visibleDialog,
            width: "40%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formDept",
              attrs: {
                rules: _vm.formDeptRules,
                "label-position": "right",
                "label-width": "80px",
                model: _vm.modelDialog
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "上级部门" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { size: "mini", placeholder: "请选择" },
                          model: {
                            value: _vm.modelDialog.parentId,
                            callback: function($$v) {
                              _vm.$set(_vm.modelDialog, "parentId", $$v)
                            },
                            expression: "modelDialog.parentId"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.modelDialog.parentDeptName,
                              value: _vm.modelDialog.parentId
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c("el-tree", {
                        ref: "tree",
                        staticStyle: {
                          "max-height": "400px",
                          "overflow-y": "auto"
                        },
                        attrs: {
                          data: _vm.superDeptsTree,
                          "show-checkbox": "",
                          "check-strictly": true,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                          "node-key": "corpGroupId",
                          "default-expand-all": true,
                          props: _vm.defaultProps
                        },
                        on: { check: _vm.handleCheck },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var node = ref.node
                                var data = ref.data
                                return _c(
                                  "div",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { title: data.groupName }
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "name",
                                        staticStyle: {
                                          overflow: "hidden",
                                          "white-space": "nowrap",
                                          "text-overflow": "ellipsis",
                                          "max-width": "100%",
                                          "padding-right": "50px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(data.groupName) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          3066849009
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门名称", prop: "departmentName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { size: "mini", placeholder: "请输入部门名称" },
                    model: {
                      value: _vm.modelDialog.departmentName,
                      callback: function($$v) {
                        _vm.$set(_vm.modelDialog, "departmentName", $$v)
                      },
                      expression: "modelDialog.departmentName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      ;(_vm.visibleDialog = false), (_vm.deptSaasVisi = false)
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleClickAddEdit()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置主管",
            visible: _vm.visibleDialogSetManager,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleDialogSetManager = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "margin-top": "-15px",
                    "padding-right": "0",
                    "text-align": "end"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        model: _vm.setManagerFilters,
                        size: "small"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "姓名/企业名称" },
                            model: {
                              value: _vm.setManagerFilters.keyword,
                              callback: function($$v) {
                                _vm.$set(_vm.setManagerFilters, "keyword", $$v)
                              },
                              expression: "setManagerFilters.keyword"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.handleClickSearchManager } },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.reset } }, [
                            _vm._v("重置")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "custom-table-style",
                  staticStyle: { "margin-top": "-15px" },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: {
                        border: "1px solid #cbcbcb",
                        "border-bottom": "0"
                      },
                      attrs: {
                        data: _vm.tableSetManager,
                        "tooltip-effect": "dark",
                        "highlight-current-row": "",
                        "header-cell-style": {
                          background: "#f9f9f9",
                          color: "#333333",
                          fontWeight: "600"
                        }
                      },
                      on: { "row-click": _vm.handleClickRow }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "姓名/企业名称",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.userName) +
                                    "\n              "
                                ),
                                scope.row.targetId != ""
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s("(" + scope.row.targetId + ")")
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "部门",
                          prop: "groupNames",
                          "show-overflow-tooltip": ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "page-flex-end",
                  staticStyle: { padding: "30px 0", position: "relative" },
                  attrs: { span: 24 }
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.setManagerFilters.itemPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.setManagerFilters.pageSize,
                      layout: "sizes, prev, pager, next, total",
                      total: _vm.setManagerFilters.pageTotal
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  }),
                  _c("el-go", {
                    attrs: {
                      "page-size": _vm.setManagerFilters.pageSize,
                      total: _vm.setManagerFilters.pageTotal
                    },
                    on: { "current-change": _vm.handleCurrentChange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleDialogSetManager = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleClickSetManagerOk()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "同步组织架构",
            visible: _vm.synchVisi,
            width: "40%"
          },
          on: {
            "update:visible": function($event) {
              _vm.synchVisi = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dia-sync-sty" }, [
            _c("div", [
              _c("h1", [_vm._v("当前钉钉的组织架构")]),
              _c(
                "div",
                { staticClass: "tree-sty" },
                [
                  _c("el-tree", {
                    attrs: {
                      "empty-text": "暂无数据",
                      data: _vm.dingTreeData,
                      props: _vm.dingTreeProp,
                      "node-key": "deptId",
                      "default-expand-all": "",
                      "highlight-current": "",
                      "check-on-click-node": true,
                      "expand-on-click-node": false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var node = ref.node
                          var data = ref.data
                          return _c(
                            "span",
                            { staticClass: "custom-tree-node" },
                            [
                              _c("span", [_vm._v(_vm._s(node.label))]),
                              _c(
                                "span",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.association(data)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.treeGroupList.includes(
                                              data.deptId.toString()
                                            )
                                              ? "修改"
                                              : "关联"
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.treeGroupList.includes(
                                            data.deptId.toString()
                                          ),
                                          expression:
                                            "treeGroupList.includes(data.deptId.toString())"
                                        }
                                      ],
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.assetsHandle(data)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  取消关联\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.synchVisi = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "reference",
                        type: "primary",
                        loading: _vm.syncConfirmLoading,
                        size: "mini"
                      },
                      on: { click: _vm.saasSyncHandle },
                      slot: "reference"
                    },
                    [_vm._v("确认同步")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.deptSaasVisi,
                    expression: "deptSaasVisi"
                  }
                ]
              },
              [
                _c("h1", [
                  _vm._v("请选择与哪个部门关联（当前君子签组织架构）")
                ]),
                _c(
                  "div",
                  { staticClass: "tree-sty" },
                  [
                    _c("el-tree", {
                      ref: "assTreeRef",
                      attrs: {
                        "empty-text": "暂无数据",
                        data: _vm.saasDeft,
                        props: _vm.GroupProp,
                        "node-key": "corpGroupId",
                        "default-expand-all": "",
                        "highlight-current": "",
                        "check-on-click-node": true,
                        "expand-on-click-node": false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: data.corpGroupId,
                                  disabled: ![
                                    "",
                                    null,
                                    "null",
                                    undefined,
                                    "undefined"
                                  ].includes(data.thirdGroupId)
                                },
                                model: {
                                  value: _vm.checkRadio,
                                  callback: function($$v) {
                                    _vm.checkRadio = $$v
                                  },
                                  expression: "checkRadio"
                                }
                              },
                              [_vm._v(_vm._s(node.label))]
                            )
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.assetsLoading,
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.assetsHandle()
                          }
                        }
                      },
                      [_vm._v("关 联")]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("调整组织架构"),
      _c("span", { staticClass: "ms" }, [
        _vm._v(
          "/\n          为企业添加下级组织架构（如分公司、部门等），为各个部门设置主管，部门主管作为按职级审批时的默认审批人。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        {
          staticStyle: {
            background: "#f9f9f9",
            color: "#333333",
            fontweight: "600",
            "text-align": "left"
          }
        },
        [
          _c("th", [_vm._v("组织名称")]),
          _c("th", [_vm._v("人数")]),
          _c("th", [_vm._v("部门主管")]),
          _c("th", [_vm._v("操作")])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d014d538", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d014d538","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/organization.vue
// module id = 7GQ8
// module chunks = 7 40 160